import { Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RxHelper } from '../../core/utils/rxjxHelper';
import { SelectionModel } from '@angular/cdk/collections';
import { Languages } from '../../core/constants';
import { DropdownModule } from 'primeng/dropdown';
import { ChipsModule } from 'primeng/chips';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-languages-select',
    standalone: true,
    imports: [CommonModule, DropdownModule, FormsModule, ChipsModule, ButtonModule],
    templateUrl: './languages-select.component.html',
    styleUrls: ['./languages-select.component.scss'],
    providers: [
        RxHelper,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LanguagesSelectComponent),
            multi: true,
        },
    ],
})
export class LanguagesSelectComponent implements OnInit, ControlValueAccessor {
    @Input() isDisabled = false;
    @Input() placeholder = '选择语言';

    private readonly _rxHelper = inject(RxHelper);

    protected readonly languages = [...Languages];
    protected readonly selectionModel = new SelectionModel<string | null>(false);
    protected onChangeFn?: (value: string | null) => unknown;
    protected onTouchedFn?: () => unknown;

    ngOnInit() {
        this.selectionModel.changed.pipe(this._rxHelper.autoUnsubscribe).subscribe(() => {
            this.onChangeFn?.(this.selectionModel.selected[0]);
        });
        this.selectionModel.select(this.languages[0].isoCode);
    }

    writeValue(obj: unknown): void {
        if (typeof obj === 'string') {
            this.selectionModel.select(obj);
        } else {
            this.selectionModel.select(null);
        }
    }

    registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    protected onChange($event: string) {
        this.selectionModel.clear();
        this.selectionModel.select($event);
    }
}
